<template>
  <path d="M20.2494 17.2495V3.74942H6.74878" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M17.2493 6.74954H3.74878V20.2495H17.2493V6.74954Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</template>
